module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_troendelag_neg.3014d7fc.svg";